export default __webpack_public_path__ + "static/media/InfoTooltipOutline.f099badc.svg";